import React, { FC } from 'react'
import { ModalPreviewMediaByYtId } from '@lib/Layout/ModalPreviewMedia'

const YoutubeVideoPreview: FC = () => <ModalPreviewMediaByYtId />

export default YoutubeVideoPreview
